<template name="pageDistribute">
	<div>
		<div class="info-card">
      <div style="display: flex;align-items: center;">
				<div style="font-weight: bold;font-size: 30px;">已分配页面名称：</div>
				<div>
					<!-- v-if 可以识别以下几种情况 null undifined [] "" false -->
					<div v-if="canReadTitle" style="font-weight: bold;font-size: 30px;">{{canReadTitle}}</div>
					<div v-else style="font-weight: bold;font-size: 30px;">暂无分配页面</div>
				</div>
				<el-button type="primary" style="margin-left: auto" :ripple="true" ripple-bg-color="#55aaff" :plain="true"
					@click="deleteProductUser" size="mini">
					<div style="font-size: 15px; font-weight: 400; font-style: normal;">取消授权此页面</div>
				</el-button>

			</div>
		</div>
    
    <div style="display: flex;justify-content: center;">
      <div style="font-weight: bold;font-size: 15px;">发布页面名称：</div>
      <el-input style="width: 60%;margin-right: 10px"
                placeholder="输入发布页面名称"
                v-model="searchTitle" @clear="clear"
                clearable>
      </el-input>
      <el-button icon="el-icon-search" circle @click="search"></el-button>
    </div>
    
		<div style="margin-top: 10px;">
			<el-table :data="product" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
				:header-cell-style="{ background: '#F2F2F2', color: '#333' }">
				<el-table-column prop="id" label="页面id" width="80" show-overflow-tooltip align="center" />
				<el-table-column prop="title" label="页面名称" width="400" show-overflow-tooltip align="center" />
				<el-table-column prop="description" label="页面描述" width="400" show-overflow-tooltip align="center" />
				<el-table-column  label="授权页面" min-width="100" show-overflow-tooltip align="center">
					<template v-slot="scope">
						<el-button @click="addMainPage(scope.row)" type="primary" size="small">授权此页面</el-button>
					</template>
				</el-table-column>

			</el-table>
		</div>
    <el-dialog title="确定给用户授权该页面？" :visible.sync="addMainPageDialogVisiable">
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMainPageDialogVisiable=false">取 消</el-button>
        <el-button type="primary" @click="confirmAddMainPage()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="确定移除该用户的授权页面？" :visible.sync="deleteProductUserDialogVisiable">
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteProductUserDialogVisiable=false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteProductUser()">确 定</el-button>
      </div>
    </el-dialog>
		<div class="button-group-card2">
			<div class="button-group-title2">
				<el-button type="primary" @click="returnBack" :plain="true">返回用户权限管理页</el-button>
			</div>
		</div>
	</div>
</template>

<script>
  import API from "@/../config/api.js";
	export default {
		name: "pageDistribute",
		props: {
			companyId: Number,
			selectUserId: Number, //指定用户分配
		},
		data() {
			return {
				projectId: '',
				pageType: '',
				pages: '',
				pageNum: 1,
				product: [],
				userId: '',
				total: '', //该项目下页面总数
				arrayFlag: [],
				permission: '',
				customStyle3: {
					color: '#4286ca',
				},
        addItem: {},//新增用户储存的信息
        addMainPageDialogVisiable: false,
        deleteProductUserDialogVisiable: false,
				searchTitle: '', //模糊搜索的页面名称
				canReadTitle: '', //用户已经分配的页面
				canReadId: '', //用户已经分配的页面id
			}
		},
		mounted() {
			this.userId = window.localStorage.getItem('userid');
			this.getProductPublishedList();
			this.getProductUserList(); //获得用户已经获得的界面权限
		},
		methods: {

      addMainPage(item){
        this.addItem = item;
        this.addMainPageDialogVisiable = true;
      },
      confirmAddMainPage() {
				let item = this.addItem;
        let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}
				let data = {
					companyId: this.companyId,
					productUserId: this.selectUserId, //选中的用户，而非登录的用户
					productId: item.id, //选定页面
				}
        this.$axiosRequest({
          url: API.insertProductUser,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res.data)
            if (res.data > 0) {
              this.$message({
                message: '添加成功',
                type: 'success',
              });
              this.addMainPageDialogVisiable = false;
              this.$emit("return");
            } else if (res.data == 0) {
              this.$message({
                message: '用户已经存在分配页面,请先删除已存在的授权关系',
                type: 'none',
              });
              return;
            } else if (res.data == -3) {
              this.$message({
                message: '不存在公司用户关系',
                type: 'none',
              });
              return;
            } else if (res.data == -2) {
              this.$message({
                message: '参数出错',
                type: 'none',
              });
              return;
            } else if (res.data == -1) {
              this.$message({
                message: '程序出错',
                type: 'none',
              });
              return;
            }
          }
        })
			},
			//获取公司所有已经发布的页面
			getProductPublishedList() {
				let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}

				let data = {
					companyId: this.companyId,
					title: this.searchTitle,
				}

				this.$axiosRequest({
					url: API.getProductPublishedList,
					method: 'POST',
					data: data,
					header: header,
					success: res => {
						this.product = res.data["productPublishedList"];
					}
				});
			},
			//获取用户已有的界面权限
			getProductUserList() {
				//加一个接口通过userId获取到已经添加权限页面的名字
				let header1 = {
					"Content-Type": "application/x-www-form-urlencoded"
				}
				let data1 = {
					companyId: this.companyId,
					productUserId: this.selectUserId,
				}
				this.$axiosRequest({
					url: API.getProductUserList,
					method: 'POST',
					data: data1,
					header: header1,
					success: res => {
						console.log(res)
						let userCanRead = res.data["productUserList"];
						console.log('eeeeeee', userCanRead)
						this.canReadTitle = userCanRead[0].title
						this.canReadId = userCanRead[0].productId
					}
				});
			},
      deleteProductUser(){
        this.deleteProductUserDialogVisiable = true;
      },
			//取消授权此页面
			confirmDeleteProductUser() {
				let header = {
					"Content-Type": "application/x-www-form-urlencoded"
				}

				let data = {
					companyId: this.companyId,
					productUserId: this.selectUserId,
					productId: this.canReadId,
				}
        this.$axiosRequest({
          url: API.deleteProductUser,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            if (res.data > 0) {
              this.$message({
                message: '删除成功',
                type: 'success',
              });
              this.deleteProductUserDialogVisiable=false;
              this.canReadTitle = ''; //显示暂无分配页面
            } else if (res.data == 0) {
              this.$message({
                message: '不存在用户界面关系',
                type: 'none',
              });
            } else if (res.data == -2) {
              this.$message({
                message: '参数出错',
                type: 'none',
              });
            } else if (res.data == -1) {
              this.$message({
                message: '程序错误',
                type: 'none',
              });
            }
          }
        });
			},
			//返回用户权限页面
			returnBack() {
				this.$emit("return");
			},
			clear() {
				this.product.length = 0; //重新刷新一下    //先把列表清空
				this.getProductPublishedList();
			},
			search() {
				this.product.length = 0; //重新刷新一下
				this.getProductPublishedList();
			}
		}
	}
</script>

<style>
	.info-title {
		font-size: 18px;
		font-weight: bold;
		color: #004768;
		font-family: '仿宋';
	}

	.info-content {
		font-size: 18px;
		font-family: '仿宋';
	}

	.info-card {
		margin: 10px 15px 10px 15px;
		padding: 12px;
		background-color: #ffffff;
	}

	.info-content {
		margin: 10px 0px 10px 10px;
		height: auto;
	}

	.title-style {
		font-size: 18px;
		font-weight: bold;
	}

	.title2-style {
		font-size: 15px;
		line-height: 40px;
	}

	.title3-style {
		font-size: 12px;
		line-height: 40px;
		color: gray
	}

	.button-group-card {
		margin: 10px 15px 10px 15px;
		background-color: rgba(240, 240, 240, 0.5);
		padding: 12px;
	}

	.button-group-title {
		font-size: 18px;
		font-weight: bold;
	}

	.button-group-card2 {
		padding: 12px;
		bottom: 0;
		right: 0;
		left: 0;
		position: fixed
	}
	
	.button-group-title2 {
		font-size: 18px;
		font-weight: bold;
		width: 450px;
		margin-left: 900px;
	}
</style>
